import { render, staticRenderFns } from "./ROICalculator.vue?vue&type=template&id=d0ff79d2&scoped=true"
import script from "./ROICalculator.vue?vue&type=script&lang=ts"
export * from "./ROICalculator.vue?vue&type=script&lang=ts"
import style0 from "./ROICalculator.vue?vue&type=style&index=0&id=d0ff79d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ff79d2",
  null
  
)

export default component.exports